import ContactUs from '../../../mixins/ContactUs';
import Footer from '@/components/Footer/Footer.vue';

import {
  KButton,
  KModal,
  KCard,
  KInput,
} from '@/components';
import WebsiteFooter from '../WebsiteFooter.vue';

export default {
  name: 'Contact',
  components: {
    KInput,
    WebsiteFooter,
    KButton,
    KModal,
    KCard,
    Footer,
  },
  mixins: [ContactUs],
};
